import { EntityModel } from '@/interfaces'
import {
  ALL_DATE_PACKAGE_SETTINGS_QUERY,
  CREATE_DATE_PACKAGE_SETTINGS_MUTATION,
  DELETE_DATE_PACKAGE_SETTINGS_MUTATION,
  FORCE_DELETE_DATE_PACKAGE_SETTINGS_MUTATION,
  SINGLE_DATE_PACKAGE_SETTINGS_QUERY,
  UPDATE_DATE_PACKAGE_SETTINGS_MUTATION,
} from './graphql'

const ratioDatePackageSettingsModel: EntityModel = {
  name: 'datePackageSettings',
  namePlural: 'datePackageSettings',
  uniqueName: 'ratioDatePackageSettings',
  uniqueNamePlural: 'ratioDatePackageSettings',
  path: 'travel/pricing/adaptors/ratio/date_package_settings',
  baseUrl: '/travel/pricing/adaptors/ratio/date_package_settings',
  translationPrefix: 'entities:ratioDatePackageSettings.',
  getDisplayName: (values: any) => {
    return 'Ratio Date Package Settings'
  },
  gql: {
    getAll: ALL_DATE_PACKAGE_SETTINGS_QUERY,
    getSingle: SINGLE_DATE_PACKAGE_SETTINGS_QUERY,
    create: CREATE_DATE_PACKAGE_SETTINGS_MUTATION,
    update: UPDATE_DATE_PACKAGE_SETTINGS_MUTATION,
    delete: DELETE_DATE_PACKAGE_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_DATE_PACKAGE_SETTINGS_MUTATION,
  },
  attributes: {
    ratioPackageNo: {
      name: 'ratioPackageNo',
      label: 'entities:ratioDatePackageSettings.attributes.ratioPackageNo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    price: {
      name: 'price',
      label: 'entities:ratioDatePackageSettings.attributes.price.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    availabilityStatus: {
      name: 'availabilityStatus',
      label: 'entities:ratioDatePackageSettings.attributes.availabilityStatus.label',
      type: 'value',
      dataType: 'number',
      defaultValue: 1,
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default ratioDatePackageSettingsModel
